import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Service } from "../../../services";
import { GlobalService } from "../../../global.service";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from "@angular/material";
import { AlertasComponent } from "../../../alertas/alertas.component";
import { LoadingScreenService } from "../../../services/loading-screen/loading-screen.service";
import { HostListener } from "@angular/core";
import { FlashController } from "src/app/flash-payment/flash-payment-core/services/flash-controller.service";
import { TRANSACTION_TYPES } from "src/app/flash-payment/flash-payment-core/constants/flash-payment-constants";
import {PaymentSupportService} from "../../../flash-payment/flash-payment-core/services/payment-support.service";
@Component({
  selector: "app-payment-options",
  templateUrl: "./payment-options.component.html",
  styleUrls: ["./payment-options.component.sass"],
})
export class PaymentOptionsComponent implements OnInit {
  @Input() selectBan;
  @Input() billBalanceField;
  @Input() token;
  @Input() paperless;
  @Input() type;
  @Input() cr;
  @Input() accountType;
  @Input() accountSubtype;
  public banlist;
  public change = 0;
  public changeSw;
  public totalCredit: number = 0;
  public credito: number = 0;
  public validDiscount = true;
  public amountPayable: any;
  public typeOfDiscount;
  public totalCreditFixed = 0;
  @Output() updateBillBalanceField = new EventEmitter();
  loadObserver: Subscription;
  paymentReceived: Subscription;

  constructor(
    private loadingScreenService: LoadingScreenService,
    private services: Service,
    private global: GlobalService,
    public dialog: MatDialog,
    private router: Router,
    private paymentSupport: PaymentSupportService
  ) {
  }

  ngOnInit() {
    this.banlist = JSON.parse(atob(sessionStorage.getItem("AccountList")));
    this.updateCredit(this.selectBan, this.billBalanceField, this.type);
    this.paymentReceived = this.global.paymentReceived.subscribe(
      (value: boolean) => {
        if (value == true) {
        }
      }
    );
  }

  updateCredit(selectBan, billBalanceField, type) {
    this.selectBan = selectBan;
    this.billBalanceField = billBalanceField;
    this.type = type;
    this.global.getCreditsByAccount(
      this.token,
      this.selectBan,
      this.billBalanceField,
      this.type
    );
    this.loadObserver = this.global.loadObserver2.subscribe((data: object) => {
      console.log(data);
      this.credito = data["credit"];
      this.totalCredit = data["totalCredit"];
      if (this.type == "prepaid") {
        this.amountPayable = 0;
      } else {
        if (this.cr == "CR") {
          this.amountPayable = 0;
        } else {
          this.amountPayable = this.billBalanceField;
        }
      }

      this.discountRule(); // calcula el credito

      if (this.credito > 0) {
        this.validDiscount = true;
      } else {
        this.validDiscount = false;
      }
    });
  }

  discountRule() {
    if (this.type == "prepaid" && this.totalCredit > 25) {
      this.credito = 25;
    } else if (
      this.type == "postpaid" &&
      this.totalCredit > 25 &&
      this.accountType == "I3" &&
      this.accountSubtype == "4"
    ) {
      this.credito = 25;
    } else if (this.type == "postpaid" && this.totalCredit > 50) {
      this.credito = 50;
    } else if (this.type == "fixed") {
      if (Number(this.credito) > 0) {
        console.log(this.credito);
        if (this.totalCredit > 50) {
          console.log(this.billBalanceField);
          this.credito = (this.billBalanceField * 50) / 100;
          this.totalCreditFixed = 50;
        } else {
          if (this.totalCredit > 0) {
            this.totalCreditFixed = this.totalCredit;

           // test
            if (this.billBalanceField > 0) {
              this.credito = (this.billBalanceField * this.totalCredit) / 100;
            }
            console.log('test1 ---->', this.billBalanceField, this.totalCredit);
          } else {
            this.totalCreditFixed = 0;
          }
        }
      }
    } else {
      this.credito = this.totalCredit;
    }
  }

  balanceUpdate(typeOfDiscount) {
    if (this.type == "postpaid") {
      if (typeOfDiscount == "high") {
        this.billBalanceField = this.billBalanceField - this.credito;
        this.amountPayable = this.billBalanceField.toFixed(2);
      } else {
        this.amountPayable = 0.0;
        this.billBalanceField = 0.0;
      }
      this.totalCredit = this.totalCredit - this.credito;
    } else if (this.type == "prepaid") {
      this.billBalanceField = parseFloat(this.billBalanceField) + this.credito;
      this.totalCredit = this.totalCredit - this.credito;
    } else if (this.type == "fixed") {
      let subtraction = (this.credito * 100) / this.billBalanceField;
      if (this.totalCredit - subtraction > 0) {
        this.totalCredit = this.totalCredit - subtraction;
      } else {
        this.totalCredit = 0;
      }
      this.global.notif(
        "Gracias por su interés en nuestro Programa Refiere y Gana!. Su balance se actualizara en su próximo ciclo de facturación."
      );
    }
    this.discountRule(); // calcula el credito
    this.updateBillBalanceField.emit(this.billBalanceField);
    this.loadingScreenService.stopLoading();
  }

  applyDescent(typeOfDiscount) {
    if (this.global.validateSession() === true) {
      var index = this.banlist
        .map(function (e) {
          return e.account;
        })
        .indexOf(this.selectBan);
      this.loadingScreenService.startLoading();
      this.services
        .applyDiscount(
          this.token,
          this.selectBan,
          this.banlist[index].subsriberByDefault,
          this.credito
        )
        .subscribe((data) => {
          if (data.hasError == false) {
            this.balanceUpdate(typeOfDiscount);
          } else {
            this.loadingScreenService.stopLoading();
            this.global.notif(data.errorDisplay);
          }
        });
    }
  }

  evaluateDescent() {
    if (this.global.validateSession() === true) {
      let message = "";
      if (this.paperless == false) {
        this.global.notif(
          "Para participar en nuestro Programa Refiere y Gana, debe suscribirse a facturación electrónica. Para detalles, verifique los términos y condiciones de este Programa."
        );
      } else if (
        (this.billBalanceField == 0 || this.cr == "CR") &&
        this.type != "fixed" &&
        this.type != "prepaid"
      ) {
        this.global.notif(
          "Para aplicar su cupón de descuento deberá tener un balance pendiente."
        );
      } else if (this.credito == 0) {
        console.log(this.credito);
        this.global.notif("En este momento no cuenta con cupones disponibles.");
      } else {
        if (this.credito > 0 && this.type == "prepaid") {
          message =
            "Una vez acepte redimir su cupón el mismo perderá su validez, este no podrá ser cancelado, reversado, reembolsado o transferido.";
        } else if (this.billBalanceField > this.credito) {
          this.typeOfDiscount = "high";
          if (this.type == "postpaid") {
            message =
              "El valor de cupón (descuento) redimido es <b>menor</b> al balance pendiente de su factura. Favor de realizar el pago remante de su factura en o antes de la fecha de vencimiento.";
          } else if (this.type == "fixed") {
            message =
              "Al aplicar su cupón, el mismo se verá reflejado en su <span class='roboto-b'>próximo</span> ciclo de facturación.";
          } else if (this.type == "prepaid") {
            message =
              "El valor de cupón (descuento) redimido es <span class='roboto-b'>menor</span> al balance pendiente de su factura. Favor de realizar el pago remante de su factura en o antes de la fecha de vencimiento.";
          }
        } else if (this.billBalanceField < this.credito) {
          this.typeOfDiscount = "low";
          if (this.type == "postpaid") {
            message =
              "El valor del cupón (descuento) redimido es <span class='roboto-b'>mayor</span> al balance pendiente de su factura, al redimir este cupón usted perderá el valor del descuento restante.";
          } else if (this.type == "fixed") {
            message =
              "Al aplicar su cupón, el mismo se verá reflejado en su <span class='roboto-b'>próximo</span> ciclo de facturación.";
          } else if (this.type == "prepaid") {
            message =
              "El valor del cupón (descuento) redimido es <span class='roboto-b'>mayor</span> al balance pendiente de su factura, al redimir este cupón usted perderá el valor del descuento restante.";
          }
        } else if (this.billBalanceField == 0 && this.type != "fixed") {
          this.typeOfDiscount = "equal";
          message =
            "Una vez acepte redimir su cupón el mismo perderá su validez, este no podrá ser cancelado, reversado, reembolsado o transferido.";
        } else if (this.billBalanceField == this.credito) {
          this.typeOfDiscount = "equal";
          message =
            "Una vez acepte redimir su cupón el mismo perderá su validez, este no podrá ser cancelado, reversado, reembolsado o transferido.";
        }
        if (this.credito > 0) {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = true;
          dialogConfig.autoFocus = true;
          dialogConfig.data = {
            inverse: true,
            colorSi: "colorRed",
            colorNo: "colorBlue",
            labelSi: "Aplicar",
            labelNo: "Regresar",
            messageHtml: true,
            message: message,
            btmConfirm: true,
          };
          const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
          dialogRef.afterClosed().subscribe((value) => {
            if (value == "continue") {
              this.applyDescent(this.typeOfDiscount);
            }
          });
        } else {
          this.global.notif(message);
        }
      }
    }
  }

  doPayment() {
    let typeMessage = "payment";
    if (this.type == "prepaid") {
      typeMessage = "prepaid";
    }
    if (this.global.validateSession() === true) {
      if (Number(this.amountPayable) <= 2000) {
        if (Number(this.amountPayable) >= 5) {

          if (sessionStorage.getItem('canUseNewMethod')) {
            this.paymentSupport.paymentRefactorProcess(typeMessage, this.amountPayable, this.selectBan, this.token);
          } else {
             this.global.newPayment(1,typeMessage,this.selectBan,atob(sessionStorage.getItem("defaultSubscriber")),this.amountPayable,atob(sessionStorage.getItem("email")),sessionStorage.getItem("name"),"",this.token);
          }

        } else {
          this.global.notif("La cantidad a pagar debe ser mayor a $5.00 o menor de $2000.00");
        }
      } else {
        this.global.notif("La cantidad a pagar debe ser mayor a $5.00 o menor de $2000.00");
      }
    }
  }



  recharge() {
    const paymentSupportPayload  = {
      typeMessage: 'prepaid',
      amountPayable: this.amountPayable,
      selectBan: this.selectBan,
      token: this.token,
      type: this.type,
    };
    sessionStorage.setItem('paymentSupportPayload', JSON.stringify(paymentSupportPayload));

    if (this.global.validateSession() === true) {
      if (this.amountPayable > 0) {
        if (this.amountPayable >= 5) {
          if (this.amountPayable <= 150) {
             this.router.navigate(["recharge/2/" + this.amountPayable]);
            // this.doPayment();
          } else {
            this.global.notif("El monto no puede ser mayor a $150.00.");
          }
        } else {
          this.global.notif("El monto no puede ser menor a $5.00.");
        }
      } else {
        this.global.notif("Debe colocar un monto para la recarga.");
      }
    }
  }



  ngOnDestroy() {
    // this.loadObserver.unsubscribe();
  }

  formatAmount(creditBalanceField: any) {
    let amount = creditBalanceField === null ? "0" : creditBalanceField;
    const splitted = amount.toString().split(".");
    amount = splitted[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    amount += ".";
    amount +=
      splitted.length > 1
        ? splitted[1].length === 1
        ? splitted[1] + "0"
        : splitted[1]
        : "00";
    return amount;
  }
}
